import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Link from 'gatsby-link'
import { indexMap } from '@helpers'
import PageWrap from '@components/PageWrap'
import Markdown from '@components/Markdown'
import TierBlockTitle from '@components/TierBlockTitle'
import { productRoute, pageRoute } from '@constants/routes'
import { renderHireProductLink } from '@helpers/RenderHireProductLink'
import './CaseStudy.module.scss'

const renderProducts = indexMap((product, index) =>
  <div styleName='productLink' key={index}>
    {R.equals(R.path(['template', '0', '__typename'], product), 'ContentfulProductTemplate') ? (
      <Link
        to={productRoute(
          renderHireProductLink(
            R.propOr('/', 'slug', product),
            R.path(['template', '0', 'category'], product)
          )
        )}
      >
        {R.path(['template', '0', 'shortName'], product)}
      </Link>
    ) : <Link to={pageRoute(R.propOr('/', 'slug', product))}>{R.prop('title', product)}</Link>}
  </div>
)

const CaseStudy = ({ caseStudy }) => {
  const getTitles = R.pipe(
    R.propOr('', 'title'),
    R.split('|')
  )
  const titles = getTitles(caseStudy)
  const bgUrl = R.path(['image', 'resize', 'src'], caseStudy)
  const intro = R.path(['intro', 'intro'], caseStudy)
  const products = R.propOr([], 'products', caseStudy)
  const content = R.prop('content', caseStudy)

  return (
    <Fragment>
      <section style={{ backgroundImage: `url(${bgUrl})` }} styleName='hero'>
        <PageWrap>
          {R.not(R.isEmpty(titles)) && <TierBlockTitle titles={titles} preTitle />}
        </PageWrap>
      </section>
      <PageWrap>
        <section styleName='case-study'>
          {intro && <div styleName='intro'>{intro}</div>}
          {R.not(R.isEmpty(products)) &&
            <div styleName='products'>
              <h3 styleName='heading'>Products</h3>
              {renderProducts(products)}
            </div>
          }
          {content && (
            <div styleName='content'>
              <Markdown content={content} />
            </div>
          )}
        </section>
      </PageWrap>
    </Fragment>
  )
}

CaseStudy.propTypes = {
  caseStudy: PropTypes.object.isRequired
}

export default CaseStudy



// WEBPACK FOOTER //
// ./src/containers/CaseStudy/CaseStudy.js